import React, {useEffect, useState, useRef} from 'react';
import { NavLink } from 'react-router-dom';
import './NavegationLinks.css';
import CallUsButton from '../../../UiElements/CallUsButton/CallUsButton';

const NavLinks = props => {

  
  const [showLoginMenu, setShowLoginMenu] = useState(false);
  const loginMenuRef = useRef(null);

  let styles = {
    borderBottom: '3px solid #fbb13b',
  };
  const [activeLink, setActiveLink] = useState(`${sessionStorage.getItem('sectionName') === 'home' ? 'home' : sessionStorage.getItem('sectionName') === 'price' ? 'price'  : 
  window.location.pathname === '/cancel-service' || 
  window.location.pathname === '/privacy-policy' || 
  window.location.pathname ==='/refund-policy' || 
  window.location.pathname ==='/terms-of-service' ? 'home' : window.location.pathname === '/checkout' ? 'price' : ''}`);
  
   const handleHomeClick = () => {
    setActiveLink('');
    window.scrollTo(0, 0);
    sessionStorage.clear();
   };

   const toggleLoginMenu = () => {
    setShowLoginMenu(prev => !prev);
  };

  // Nuevo manejador específico para la flecha
  const handleArrowClick = (e) => {
    e.stopPropagation(); // Esto previene que el evento se propague al botón padre
    setShowLoginMenu(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (loginMenuRef.current && !loginMenuRef.current.contains(event.target)) {
        setShowLoginMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <React.Fragment>
    <ul className="nav-links" >
      <li>
        <NavLink  to="/"  onClick={handleHomeClick} style={activeLink === 'home' ? styles : {}} exact>HOME</NavLink> 
      </li>

      <li>

        <NavLink to="/about-us" onClick={handleHomeClick} >ABOUT US</NavLink>  
        
      </li>

      <li>
         <NavLink to="/price" onClick={handleHomeClick} style={activeLink === 'price' ? styles : {}} >PRICE</NavLink>
      </li>

      <li>
        <NavLink to="/contact" onClick={handleHomeClick} >CONTACT</NavLink>
      </li>
      <li>
        <NavLink to="/cancel-service" onClick={handleHomeClick} >CANCEL</NavLink>
      </li>

      <li className="login-dropdown" ref={loginMenuRef}>
          <button onClick={toggleLoginMenu}>
            LOGIN 
            <span 
              className="login-arrow" 
              onClick={handleArrowClick} // Usamos el nuevo manejador
            >
              {showLoginMenu ? "▾" : "▸"}
            </span>
          </button>
          
          {showLoginMenu && (
            <ul className="login-submenu">
              <li>
                <a href="https://portal.yourcybersentinel.com/" target="_blank" rel="noopener noreferrer">Legacy portal</a>
              </li>
              <li>
                <a href="https://cybersentinel.idcommandcenter.com/" target="_blank" rel="noopener noreferrer">New portal</a>
              </li>
            </ul>
          )}
        </li>


       <li className='NavLinks__call-us-button-link' >
        <CallUsButton
        phonenumber="CALL NOW"
        />
      </li> 
    </ul>
    

    </React.Fragment>
  );
};

export default NavLinks;
